import { EventTypes, IReducerPayload, IIconReducer } from './EventTypes';
import { IReduxAction } from '@core-web/redux';

const initialState: IIconReducer = {};

export const IconReducer = (state = initialState, { type, payload }: IReduxAction<EventTypes, IReducerPayload>) => {
  switch (type) {
    case EventTypes.ICON_LOADED: {
      return { ...state, [payload?.icon as string]: true };
    }
    default: {
      return state;
    }
  }
};
